import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"

import { BuildingReferencePage } from "pages/building-reference-page/BuildingReferencePage"

interface InstallationReferencePageProps {
  page: InstallationReferenceObj
}

export function InstallationReferencePage({
  page
}: InstallationReferencePageProps) {
  const parent = page.parent() as BuildingReferenceObj | null
  const navigate = useNavigate()

  useEffect(() => {
    navigate(`#installation-${page.id()}`)
  }, [page.id()])

  if (parent) {
    return <BuildingReferencePage page={parent} />
  }
  return null
}
